export default {
  "content": "<g clip-path=\"url(#clip0_431_53623)\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12zM13.44 6.88c0 .64-.51 1.12-1.11 1.12-.63 0-1.13-.48-1.13-1.12 0-.62.51-1.13 1.13-1.13.6 0 1.11.5 1.11 1.13zm-1 11.12H10c-.55 0-1-.45-1-1s.45-1 1-1h1.44v-4H10c-.55 0-1-.45-1-1s.45-1 1-1h2.44c.55 0 1 .45 1 1v5h1.45c.55 0 1 .45 1 1s-.45 1-1.01 1h-2.44z\" fill=\"#3F4450\"/></g><defs><clipPath id=\"clip0_431_53623\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};